import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PublicAPI } from "../api";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    PublicAPI.get(`auth/verify-email/?token=${token}`)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-200 p-10 text-center">

        {status === "verifying" && (
          <>
            <div className="flex justify-center mb-5">
              <svg className="h-10 w-10 text-[#282E6A] animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Verifying your email…</h2>
            <p className="text-sm text-gray-500">This will only take a moment.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="flex justify-center mb-5">
              <div className="h-14 w-14 rounded-full bg-green-100 flex items-center justify-center">
                <svg className="h-7 w-7 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Email verified</h2>
            <p className="text-sm text-gray-500 mb-7">
              Your email has been successfully verified. You can now log in to your account.
            </p>
            <Link
              to="/login"
              className="inline-block w-full py-2.5 bg-[#282E6A] hover:bg-[#1e2458] text-white text-sm font-medium rounded-lg transition"
            >
              Log in to Hindsight
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <div className="flex justify-center mb-5">
              <div className="h-14 w-14 rounded-full bg-red-100 flex items-center justify-center">
                <svg className="h-7 w-7 text-red-500" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Verification failed</h2>
            <p className="text-sm text-gray-500 mb-7">
              This link is invalid or has expired. Try registering again, or resend the verification email from your profile.
            </p>
            <Link
              to="/register"
              className="inline-block w-full py-2.5 bg-[#282E6A] hover:bg-[#1e2458] text-white text-sm font-medium rounded-lg transition mb-3"
            >
              Back to sign up
            </Link>
            <a
              href="mailto:hindsightin@gmail.com"
              className="block text-sm text-[#282E6A] hover:underline"
            >
              Contact support
            </a>
          </>
        )}
      </div>
    </div>
  );
}
